<template>
  <div v-bind:class="{ error: showError }" class="form-control">
    <label>{{ value.label }}</label>
    <div class="facet-input-field ranges" data-prefix='$'>
      <input type="number" ref="min"  min=0  placeholder="From" :value="value.min" @input="updateRangeFacet()">
      <div></div>
      <input type="number" ref="max" min=0  placeholder="To" :value="value.max" @input="updateRangeFacet()">
    </div>
    <p v-if="showError">Please select a valid {{ labelInLowerCase }}.</p>
  </div>
</template>

<script>
import _ from "lodash";

export default {
  props: ["value"],
  computed: {
    labelInLowerCase() {
      return this.value.label.toLowerCase().trim();
    },
    showError() {
      return !this.value.valid && this.value.min && this.value.max;
    }
  },
  created() {
    this.updateRangeFacet = _.debounce(function(){
      this.$emit("input", this.getUpdatedValueFromInput());
    }, 200);
  },
  methods: {
    getUpdatedValueFromInput() {
      let valid = true;
      if (this.$refs.max.value && this.$refs.min.value) {
        valid = parseFloat(this.$refs.max.value) >= parseFloat(this.$refs.min.value);
      }

      return _.assign({}, this.value, {
        min: this.$refs.min.value,
        max: this.$refs.max.value,
        value: this.$refs.min.value + "-" + this.$refs.max.value,
        valid: valid
      });
    },
  }
};
</script>